<template>
  <div class="dashboard__inner_body">
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>